import { render, staticRenderFns } from "./BenefitsTbRuTinkoff.vue?vue&type=template&id=05f18b76"
import script from "./BenefitsTbRuTinkoff.vue?vue&type=script&lang=js"
export * from "./BenefitsTbRuTinkoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports